import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { COOKIE_REGION_URL } from '../../../consts';
import { selectLoading } from '../../../store/products';
import { List } from './List';
import {
  Product,
  ProductRemoved,
  ProductSkeleton
} from '../../elements/Product';
import { useProductsLists } from './hooks/useProductsLists';
import { useProductsForDeletion } from './hooks/useProductsForDeletion';
import { ProductsListsProps } from './types';
import styles from './ProductsLists.scss';

export const ProductsLists: FC<ProductsListsProps> = ({
  predictCartCount
}) => {
  const loading = useSelector(selectLoading);
  const lists = useProductsLists();
  const { onDelete, onCancel } = useProductsForDeletion();
  const regionUrl = Cookies.get(COOKIE_REGION_URL) || '/';

  return (
    <div className={styles.root}>
      {loading === 'idle' ? (
        <List>
          {Array.from(
            { length: predictCartCount },
            () => null
          ).map((_: number, key: number) => (
            <ProductSkeleton key={key} />
          ))}
        </List>
      ) : (
        lists.map((list) => (
          <List key={list.id} title={list.title}>
            {list.products.map(
              ({ id, forDeletion, isDeleted, ...item }) =>
                isDeleted ? null : forDeletion ? (
                  <ProductRemoved
                    id={id}
                    key={id}
                    name={item.name}
                    picture={item.picture}
                    onDelete={onDelete}
                    onCancel={onCancel}
                  />
                ) : (
                  <Product
                    id={id}
                    key={id}
                    regionUrl={regionUrl}
                    {...item}
                  />
                )
            )}
          </List>
        ))
      )}
    </div>
  );
};
